module.exports = __webpack_public_path__ + "static/media/fast_rewind.a38fe799.svg";